import Text from '@cartwhl/ui/base/TextNew';

import { pageFrame } from '../page-frame';
import ComicPerformanceChart from './ComicPerformanceChart/index';
import ModelIntro from './ModelIntro';
import {
  ActionCard,
  CapabilityCard,
  ModelCard,
  SectionLabel,
} from './components';
import { commitContent } from './content';

export default function CommitPage() {
  return (
    <div className={pageFrame}>
      <ModelIntro intro={commitContent.intro} model="comic" />
      <section className="border-primary flex flex-col gap-10 border-b px-4 py-10 sm:gap-20 sm:px-12 sm:py-20">
        <SectionLabel>Models</SectionLabel>
        <div className="grid gap-6 lg:grid-cols-2 xl:grid-cols-3">
          {commitContent.models.map((card) => (
            <ModelCard key={card.id} card={card} />
          ))}
        </div>
      </section>
      <section className="border-primary border-b px-4 py-20 sm:px-12">
        <Text
          as="h2"
          token={{
            base: 'display/32/bold',
            sm: 'display/56/bold',
            xl: 'display/88/bold',
          }}
          leading="headline"
          className="max-w-[1320px] text-pretty"
        >
          The fastest, most accurate, feature-rich{' '}
          <span className="text-green">video performance capture model.</span>
        </Text>
      </section>
      <section className="border-primary flex flex-col gap-10 border-b px-4 py-10 sm:gap-20 sm:px-12 sm:py-20">
        <SectionLabel>Capabilities</SectionLabel>
        <div className="grid gap-6 lg:grid-cols-2 xl:grid-cols-3">
          {commitContent.capabilities.map((capability) => (
            <CapabilityCard
              key={capability.id}
              capability={capability}
              className="xl:min-h-[373px]"
              mediaClassName="aspect-video"
            />
          ))}
        </div>
      </section>
      <section
        id="comic-performance"
        className="border-primary flex scroll-mt-24 flex-col gap-10 border-b px-4 py-10 sm:gap-20 sm:px-12 sm:py-20"
      >
        <SectionLabel>Performance</SectionLabel>
        <ComicPerformanceChart performance={commitContent.performance} />
      </section>
      <section className="border-primary flex flex-col gap-10 border-b px-4 py-10 sm:gap-20 sm:px-12 sm:py-20">
        <div className="flex max-w-[813px] flex-col gap-10">
          <SectionLabel>{commitContent.action.title}</SectionLabel>
          <Text
            as="p"
            token={{ base: '16', sm: '32' }}
            leading="body"
            className="text-secondary text-pretty"
          >
            {commitContent.action.description}
          </Text>
        </div>
        <div className="grid gap-6 sm:grid-cols-2">
          {commitContent.action.cards.map((card) => (
            <ActionCard key={card.id} {...card} />
          ))}
        </div>
      </section>
    </div>
  );
}
